module.exports = __webpack_public_path__ + "static/receptionist-talking-intake-55235d26a96fae5efe042684306cd211.jpg";